import { render, staticRenderFns } from "./ComponentFieldSet.vue?vue&type=template&id=b1212bb2&scoped=true&"
import script from "./ComponentFieldSet.vue?vue&type=script&lang=js&"
export * from "./ComponentFieldSet.vue?vue&type=script&lang=js&"
import style0 from "./ComponentFieldSet.vue?vue&type=style&index=0&id=b1212bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1212bb2",
  null
  
)

export default component.exports